var _a;
import { __generator } from "tslib";
import { call, put, select } from 'redux-saga/effects';
import { getCurrentUser } from '../../publicSession/selectors';
import { selectors, withOffset } from '../../Stream';
import { DeviationTypes } from '../../types/deviation';
import { fetch, fakeResponseForType } from './helpers';
import { MEDIA_POPUP_POLL_STREAM_ID, MEDIA_POPUP_STATUS_STREAM_ID, MEDIA_POPUP_JOURNAL_STREAM_ID, MEDIA_POPUP_POSTS_STREAM_ID, } from '../constants';
import { normalizeDeviations } from '../../redux/normalizr/helpers';
var streamIdToDeviationTypeMap = (_a = {},
    _a[MEDIA_POPUP_POLL_STREAM_ID] = DeviationTypes.POLL,
    _a[MEDIA_POPUP_STATUS_STREAM_ID] = DeviationTypes.STATUS,
    _a[MEDIA_POPUP_JOURNAL_STREAM_ID] = DeviationTypes.JOURNAL,
    _a[MEDIA_POPUP_POSTS_STREAM_ID] = 'all_posts',
    _a);
function handlePostStreamFetch(action) {
    var streamId, type, _a, offset, limit, username, params, fakeResponse, response, hasMore, results, normalized;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                streamId = action.streamId;
                type = streamIdToDeviationTypeMap[streamId];
                return [4 /*yield*/, select(function (state) { return ({
                        username: getCurrentUser(state).username,
                        offset: withOffset.selectors.getNextOffset(state, streamId),
                        limit: selectors.getItemsPerFetch(state, streamId),
                    }); })];
            case 1:
                _a = _d.sent(), offset = _a.offset, limit = _a.limit, username = _a.username;
                params = {
                    type: type === 'all_posts' ? 'all' : type,
                    username: username,
                    offset: offset,
                    limit: limit,
                };
                fakeResponse = fakeResponseForType(type);
                return [4 /*yield*/, call(fetch, {
                        url: 'posts/fetch',
                        params: params,
                        fakeResponse: fakeResponse,
                    })];
            case 2:
                response = _d.sent();
                if (!!response) return [3 /*break*/, 4];
                return [4 /*yield*/, put(withOffset.actions.fetchFailure({
                        streamId: streamId,
                        errorMsg: 'Failed to fetch',
                    }))];
            case 3:
                _d.sent();
                return [2 /*return*/];
            case 4:
                hasMore = response.hasMore, results = response.results;
                normalized = results && normalizeDeviations(results);
                return [4 /*yield*/, put(withOffset.actions.fetchSuccess({
                        streamId: streamId,
                        hasMore: results ? !!hasMore : false,
                        items: (_b = normalized === null || normalized === void 0 ? void 0 : normalized.result) !== null && _b !== void 0 ? _b : [],
                        entities: (_c = normalized === null || normalized === void 0 ? void 0 : normalized.entities) !== null && _c !== void 0 ? _c : {},
                    }))];
            case 5:
                _d.sent();
                return [2 /*return*/];
        }
    });
}
export default handlePostStreamFetch;
//# sourceMappingURL=postStreamFetch.js.map